import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "#/components/app-layout";

// Korean app chrome — same AppLayout as the root `/_app`, mounted under `/ko`.
export const Route = createFileRoute("/ko/_app")({
	component: AppLayout,
});
